export default {
    baseStyle: (props) => {
        const {step} = props
        const indicatorLeft =
            step === 'rigid' || step === 'small'
                ? '0px'
                : step === 'comfort' || step === 'regular'
                  ? 'calc(50% - 16px)'
                  : 'calc(100% - 32px)'

        return {
            accordion: {
                w: 'full'
            },
            descriptionWrapper: {
                mt: {lg: 4},
                mb: {base: 6, lg: 8}
            },
            descriptionHeading: {
                variant: 'accordionPdp',
                textAlign: 'left',
                textStyle: 'webH4',
                mb: 4
            },
            descriptionContent: {
                textStyle: 'bodyXsRegular'
            },
            stretchScaleWrapper: {
                mt: {base: 2},
                mb: {base: 6, lg: 8},
            },
            stretchScaleHeading: {
                variant: 'accordionPdp',
                flex: '1',
                textAlign: 'left',
                textStyle: 'webH4',
                mb: 4
            },
            stretchScalePadding: {
                padding: '8px 0'
            },
            stretchScaleOuter: {
                w: '100%'
            },
            stretchScaleBar: {
                position: 'relative',
                w: '100%',
                h: '2px',
                bg: 'webBasic.400',
                mb: 2
            },
            stretchScaleIndicator: {
                position: 'absolute',
                top: 0,
                h: '2px',
                w: '32px',
                bg: 'black',
                left: indicatorLeft
            },
            stretchScaleLabels: {
                display: 'flex',
                justifyContent: 'space-between'
            },
            stretchScaleLabelLeft: {
                textStyle: 'bodyXsRegular',
                minW: '52px'
            },
            stretchScaleLabelCenter: {
                textStyle: 'bodyXsRegular',
                minW: '52px',
                textAlign: 'center'
            },
            stretchScaleLabelRight: {
                textStyle: 'bodyXsRegular',
                minW: '52px',
                textAlign: 'right'
            },
            navButton: {
                variant: 'link',
                textDecoration: 'none',
                w: 'full',
                minH: {base: '40px'},
                mb: 0
            },
            navItemText: {
                variant: 'accordionPdp',
                textAlign: 'left',
                justifyContent: 'space-between',
                alignItems: 'center',
                w: 'full',
                display: 'flex',
                textStyle: 'webH4'
            },
            checkBalanceButton: {
                variant: 'link',
                textDecoration: 'none',
                w: 'full',
                mb: 2
            },
            navLink: {
                textDecoration: 'none',
                w: 'full',
                mb: 2,
                display: 'block'
            },
            termsLink: {
                textDecoration: 'none',
                w: 'full',
                display: 'block'
            },
            spacer: {
                display: ['none', 'none', 'none', 'block'],
                flex: 4
            }
        }
    }
}
